/* eslint-disable no-param-reassign */
export default (state) => {
  // TODO: Hm
  state.workflows = [];
  state.trayUserId = undefined;
  state.trayUserToken = undefined;
  state.trayInstances = [];
  state.inProgressTrayInstance = { instance: undefined, loading: undefined, success: undefined };
  state.status = { loading: true, success: undefined, error: undefined };
};
